import React, { FC } from "react";
import { MeRepositoryProvider } from "./store/Me";

interface GlobalState {
  dark_mode: boolean;
}

const DefaultGlobalState: GlobalState = {
  dark_mode: true,
};

export const GlobalStateContext = React.createContext(DefaultGlobalState);
export const DispatchStateContext = React.createContext<
  React.Dispatch<GlobalState>
>(() => {});

export const GlobalStateProvider: FC = ({ children }) => {
  const [state, dispatch] = React.useReducer(
    (state: GlobalState, new_value: GlobalState) => ({
      ...state,
      ...new_value,
    }),
    DefaultGlobalState
  );

  return (
    <GlobalStateContext.Provider value={state}>
      <DispatchStateContext.Provider value={dispatch}>
        <MeRepositoryProvider>{children}</MeRepositoryProvider>
      </DispatchStateContext.Provider>
    </GlobalStateContext.Provider>
  );
};

export const useGlobalState = () => ({
  global_state: React.useContext(GlobalStateContext),
  set_global_state: React.useContext(DispatchStateContext),
});
